import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 526px;
  border-radius: 3px;
  border: 1px solid #cecece;
  margin: 7px;
  padding: 10px;
  background: #f7f7f7;
  justify-content: space-between;
`;

export const Content = styled.div`
  margin-top: 7px;

  input {
    width: calc(100px - 32px);
  }

  div {
    padding-right: 10px;
    &:last-child {
      padding-right: 0;
    }
  }

  div.mini.input {
    padding-right: 10px;
  }
`;

export const Editor = styled.textarea`
  font-family: Lato, 'Helvetica Neue', Arial, Helvetica, sans-serif;
  min-height: 100px;
  font-size: 11pt;
  line-height: 12pt;
  resize: vertical;
  border: 1px solid rgba(128, 128, 128, 0.15);
  border-radius: 3px;

  width: 100%;
  height: 100%;
`;
